import { AiseaApiFactory } from "@/api/aisea/apiFactory";

// 年度設定マスタ
const enterpriseCrewsFiscalYeatDefaultsRepository = AiseaApiFactory.get(
  "enterpriseCrewsFiscalYeatDefaults"
);

/**
 * 年度設定マスタサービス
 */
const EnterpriseCrewsFiscalYeatDefaultsService = (() => {
  let _enterpriseCrewsFiscalYeatDefaults = null;

  /**
   * 年度設定マスタデータを取得する
   * @returns {Promise<Object>} 年度設定マスタデータ
   */
  const fetch = async () => {
    const res = await enterpriseCrewsFiscalYeatDefaultsRepository.fetch();
    if (!res || !res.status) {
      throw res;
    }

    _enterpriseCrewsFiscalYeatDefaults = res.data;
    return _enterpriseCrewsFiscalYeatDefaults;
  };

  const clear = () => {
    _enterpriseCrewsFiscalYeatDefaults = null;
  };

  /**
   * 会計年度を指定して、年度設定マスタデータを取得する
   * @param {Number} fiscalYear 会計年度
   * @returns
   */
  const findByFiscalYear = fiscalYear => {
    if (!_enterpriseCrewsFiscalYeatDefaults) {
      return null;
    }
    return (
      _enterpriseCrewsFiscalYeatDefaults.fiscal_year_defaults.find(
        year => year.fiscal_year === fiscalYear
      ) || null
    );
  };

  /**
   * 会計年度を指定して、基本乗船期間日数を取得する
   * @param {Number} fiscalYear 会計年度
   * @returns {number|null} 基本乗船期間日数
   */
  const getBasicBoardingDays = fiscalYear => {
    const fiscalYearData = findByFiscalYear(fiscalYear);
    if (!fiscalYearData || !fiscalYearData.basic_boarding_days) {
      return null;
    }
    return fiscalYearData.basic_boarding_days || null;
  };

  return {
    fetch,
    clear,
    getBasicBoardingDays,
    findByFiscalYear,
  };
})();

export default EnterpriseCrewsFiscalYeatDefaultsService;
